import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumb = ({ items = [] }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: it.label,
      item: `https://uppit.nl${it.href || ""}`,
    })),
  };
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumb"
      className="text-[11px] font-mono uppercase tracking-[0.22em] text-coal/45"
    >
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((it, i) => (
          <li key={it.href || i} className="flex items-center gap-2">
            {i > 0 && <ChevronRight className="w-3 h-3 text-coal/30" />}
            {i < items.length - 1 ? (
              <Link to={it.href} className="hover:text-electric transition-colors">
                {it.label}
              </Link>
            ) : (
              <span className="text-coal/70">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
